import { Model } from './model';
import { ClientFeedConfiguration, Project } from './project';
import { WidgetTemplate } from './widget';

export class ClientInfo {
  projectCount: number;
  userCount: number;
}

export class Client extends Model {
  latestProjects: Project[];
  name: string;
  slug: string;
  feedConfigurations: ClientFeedConfiguration[];
  widgetTemplates: WidgetTemplate[];
  info: ClientInfo;

  constructor(data?) {
    super(data);

    if (data) {
      this.name = data.name;
      this.slug = data.slug;
      if (data.feed_configurations) {
        this.feedConfigurations = data.feed_configurations ? data.feed_configurations.data.map(feed => {
          return new ClientFeedConfiguration(feed);
        }) : [];
      }

      if (data.widget_templates) {
        this.widgetTemplates = data.widget_templates ? data.widget_templates.data.map(feed => {
          return new WidgetTemplate(feed);
        }) : [];
      }

      if (data.info) {
        this.info = new ClientInfo();
        this.info.projectCount = data.info.project_count;
        this.info.userCount = data.info.user_count;
      }

      if (data.latest_projects) {
        this.latestProjects = data.latest_projects.data.map(d => new Project(d));
      }
    }
  }

  toJson(): any {
    return undefined;
  }

  static fromJson(row: any) {
    return new Client(row);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/client.ts